import { render, staticRenderFns } from "./nyzt.vue?vue&type=template&id=6f925546&scoped=true&"
import script from "./nyzt.vue?vue&type=script&lang=js&"
export * from "./nyzt.vue?vue&type=script&lang=js&"
import style0 from "./nyzt.vue?vue&type=style&index=0&id=6f925546&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f925546",
  null
  
)

export default component.exports